/**
 * Componente que inicializa la aplicación
 */

import React from 'react';
import ReactDOM from 'react-dom';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/storage';
import 'firebase/compat/functions';
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { Provider } from 'react-redux';
import { ReactReduxFirebaseProvider, getFirebase } from 'react-redux-firebase';
import { createFirestoreInstance } from 'redux-firestore';


import * as serviceWorker from './serviceWorker';
import { reducers } from './application/reducers';
import { settings } from './config/services';
import { Router } from './application/navigation';

/**
 * Inicializa y configura las instancias de firebase
 */
firebase.initializeApp( settings.firebase.config );
firebase.firestore();

// Persistencia explícita LOCAL para evitar pérdida de sesión en navegadores
// que silenciosamente degradan a SESSION o NONE (Chrome móvil con políticas
// de privacidad, modo incógnito, storage saturado, etc.). Esto era la
// hipótesis fuerte de por qué los clientes en Pixel 9 reportaban "me
// desloguea": el SDK no encontraba sesión persistida al recargar la app.
//
// LOCAL = persiste hasta logout explícito (IndexedDB).
// SESSION = solo dentro de la pestaña actual.
// NONE = in-memory, se pierde al recargar.
firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
  .catch(err => console.warn('[auth] setPersistence(LOCAL) falló:', err?.message));

/**
 * Crea un store que permite la comunicación entre las acciones y los reductores de REDUX
 */
const store = createStore(
  reducers,
  compose(
    applyMiddleware( thunk.withExtraArgument( getFirebase ) )
  )
);

const rrfProps = {
  firebase,
  config: settings.reactReduxFirebase.config,
  dispatch: store.dispatch,
  createFirestoreInstance
};


ReactDOM.render(
  // <React.StrictMode>
    <Provider store = { store } >
      <ReactReduxFirebaseProvider {...rrfProps}>
        <Router />
      </ReactReduxFirebaseProvider>
    </Provider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
